// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"R4-z","dimensionLabel":"S4-z","styleChooserControlWrapper":"T4-z","styleChooserControl":"U4-z","disabled":"V4-z","giftCard":"W4-z","styleChooserText":"X4-z"};